





































import Vue from 'vue';
import { CommentExpression } from 'expangine-runtime';
import ExpressionBase from '../ExpressionBase';


export default ExpressionBase<CommentExpression>().extend({
  name: 'CommentEditor',
  data: () => ({
    editing: false,
  }),
  computed: {
    readOnlyHTML() {
      return this.value.comment.replace(/\n/g, '<br>');
    },
  },
  methods: {
    edit() {
      if (!this.readOnly) {
        this.editing = true;
      }
    },
    finishEdit() {
      this.editing = false;
    },
  },
});
